import { TmHttpClient } from '@treasury/core/http';
import { WirePaymentDto } from '../../types/wire/wire-payment-dto.types';

export class WirePaymentsService {
    // eslint-disable-next-line no-useless-constructor
    constructor(private readonly http: TmHttpClient) {}

    async fetchWireActivity(body: any) {
        const response = await this.http.request<WirePaymentDto[]>('wires/Search?type=One+Time', {
            method: 'POST',
            body,
        });

        return {
            data: response,
            totalCount: response.length,
        };
    }
}
